import React from 'react';
import { useSelector } from 'react-redux';
import { Select, Form } from 'ui/components';

export const FormItems = ({ data, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  return (
    <div className="mt-3">
      <div className="fw-semibold py-2 fs-6">Data Item</div>
      <div className="py-3">
        {data?.map((e, i) => (
          <div className={'row align-items-end border-bottom py-3 m-0'} key={i}>
            <div className="col-12">
              <div className="row">
                <>
                  <div className="col-md-3 ps-0">
                    <div className="mb-3">
                      <Select.Remote
                        label="Pilih Item"
                        required
                        placeholder=""
                        url="/wms/item"
                        initialValue={e?.item_id}
                        params={{ is_active: 'active' }}
                        name="item_id"
                        row={(d) => {
                          return {
                            value: d?.id,
                            label: d?.alias_name,
                          };
                        }}
                        errors={
                          StateForm?.errors?.items ||
                          StateForm?.errors[`items.${i}.item_id`]
                        }
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-2 ps-0 ">
                    <Form.Input
                      autoComplete="off"
                      label="Unit"
                      name="unit_name"
                      type="text"
                      value={e?.unit_name}
                      disabled
                    />
                  </div>
                  <div className="col-md-2 ps-0 ">
                    <Form.Input
                      autoComplete="off"
                      label="Stok"
                      name="current_stock"
                      type="text"
                      value={e?.current_stock}
                      disabled
                    />
                  </div>
                  <div className="col-md-2 ps-0 ">
                    <Form.Input
                      required
                      autoComplete="off"
                      label="Defect Quantity"
                      name="quantity_defect"
                      type="number"
                      value={e?.quantity_defect}
                      onChange={(e) => onInputChange(i, e)}
                      error={
                        StateForm?.errors?.items ||
                        StateForm?.errors[`items.${i}.quantity_defect`]
                      }
                    />
                  </div>
                  <div className="col-md-3 ps-0 ">
                    <Form.Input
                      required
                      autoComplete="off"
                      label="Stok opname"
                      name="quantity"
                      type="number"
                      value={e?.quantity}
                      onChange={(e) => onInputChange(i, e)}
                      error={
                        StateForm?.errors?.items ||
                        StateForm?.errors[`items.${i}.quantity`]
                      }
                    />
                  </div>
                </>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
